'use strict';

import SearchRoute from './SearchRoute';

export default class SearchRoutes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpened: true,
            errors: [],
            maxRoutes: props.maxRoutes || 5,
        }
        this.addRoute = this.addRoute.bind(this)
        this.handleChangeRoute = this.handleChangeRoute.bind(this)
        this.removeRoute = this.removeRoute.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
    }
    
    componentDidMount() {
        if (this.items.length < 3)
        {
            this.setState ( { isOpened: true } );
        }
    }
    
    get items() {
        const {routes} = this.props;
        const items = [];
        routes.map((route, index) => {
            if(!!route.from.id && (index === 0 || routes[index - 1].to.id !== route.from.id)) items.push(route.from)
            if(!!route.to.id) items.push(route.to)
        })
        return items;
    }

    addRoute(e, backRoute = null) {
        e.preventDefault();

        const {onChangeRoutes} = this.props;
        const {maxRoutes} = this.state;

        let routes = [...this.props.routes];
        if(routes.length >= maxRoutes) return;

        let route = {from: {}, to: {}, date: '', time: '', seats: 0}
        if(backRoute !== null) {
            route = {
                ...routes[backRoute],
                from: routes[backRoute].to,
                to: routes[backRoute].from,
                date: '',
                time: '',
                seats: 0,
            };
        }

        routes.push(route);
        onChangeRoutes(routes);
    }

    removeRoute(e, index) {
        e.preventDefault();
        const {onChangeRoutes} = this.props;
        let routes = [...this.props.routes];
        onChangeRoutes(routes.filter((r, i) => i !== index));
    }

    handleChangeRoute(index, route) {
        const {onChangeRoutes} = this.props;
        let routes = [...this.props.routes];
        routes[index] = route;
        onChangeRoutes(routes);
    }

    getRoutes() {
        const {type, routes} = this.props;
        return  ['planes', 'plane'].includes(type) ? routes : routes.slice(0, 1);
    }

    validate() {
        const {type, routes} = this.props;
        let errors = [];
        let hasErrors = false
        routes.map((route, index) => {
            errors.push([]);
            if(!route.from.id) errors[index].push('from');
            if(!route.to.id) errors[index].push('to');
            if(!route.date) errors[index].push('date');
            if(type === 'planes') {
                if (!route.time) errors[index].push('time');
                if (!route.seats) errors[index].push('seats');
            }
            if(errors[index].length > 0) hasErrors = true;
        })
        this.setState({errors});
        return !hasErrors;
    }

    handleSearch() {
        const {onSearch} = this.props;
        if(this.validate()) this.setState({isOpened: false}, onSearch);
    }

    render() {
        const {type, requestMode = false, routes, airports, containerClass: userContainerClass, errors: propsErrors} = this.props;
        const {isOpened, errors: stateErrors, maxRoutes} = this.state;

        const errors = [...(Array.isArray(propsErrors) ? propsErrors : []), ...(stateErrors || [])]

        if(!requestMode && !isOpened && type === 'planes') {
            const itemsLength = this.items.length;
            if(itemsLength >= 3) {
                return <div className="sesrch-route">
                    <div className="sesrch-route__row">
                        {this.items.map(item => <div className="route-item">
                            {itemsLength <= 4 && <div className="route-item__text">{item.city}</div>}
                            <span className={itemsLength <= 4 && 'route-item__code'}>{item.icao}</span>
                        </div>)}
                    </div>
                    <div className="route-btn">
                        <a className="button button-base" onClick={() => this.setState({isOpened: true})}>{tMsg('Изменить')}</a>
                    </div>
                </div>
            }
        }

        let containerClass = ['search', userContainerClass]
        if(type === 'sharing') containerClass.push('request-sharing')
        if(type === 'emptyleg') containerClass.push('request-el')

        return <div className={containerClass.join(' ')}>
            {this.getRoutes().map((route, index) => <SearchRoute
                key={index}
                type={type}
                dateRange={type === 'emptyleg'}
                index={index}
                route={route}
                errors={errors[index] || []}
                airports={airports}
                onChangeRoute={this.handleChangeRoute}
                onRemove={this.removeRoute}
                onSearch={this.handleSearch}
            />)}

            {type === 'planes' && <div className="search-btns">
                {routes.length < maxRoutes && <a href='#' className="search-button button-add" onClick={this.addRoute}>
                    <span>+</span> {tMsg('Добавить маршрут')}
                </a>}
                <button className="search-button button-search" onClick={() => this.handleSearch()}>{tMsg('Поиск')}</button>
            </div>}

            {type === 'plane' && <div className="search-btns__request">
                {routes.length < maxRoutes && <a href='#' className="button-add" onClick={this.addRoute}>
                    <span>+</span> {tMsg('Добавить маршрут')}
                </a>}
                {routes.length === 1 && routes[0].from.id && routes[0].to.id && <a href='#' className="button-add" onClick={e => this.addRoute(e, 0)}>
                    <i className="icon-arrow4"/> {tMsg('Обратный перелёт')}
                </a>}
            </div>}
        </div>
    }
}